/**
 * // src/data/assetsData.ts
 *
 * This module creates an instance of the AssetArray class with the Asset data for our desired coins
 * 
 * It also has two helper arrays for CoinGecko and Binance pair definitions.  These are also embedded in our assetsInfo array
 * 
 */

import {
  Asset,
  AssetArray,
} from '../types/Assets';

export const assets: Asset[] = [
    { id: 1, prettyname: "Bitcoin", chain: "BTC", tinyName: "BTC", shortName: "BTC.BTC", longName: "BTC.BTC", geckoName: "bitcoin", binancePair: "BTCUSDT"},
    { id: 2, prettyname: "Ethereum", chain: "ETH", tinyName: "ETH", shortName: "ETH.ETH", longName: "ETH.ETH", geckoName: "ethereum", binancePair: "ETHUSDT" },
    { id: 3, prettyname: "USDC", chain: "ETH", tinyName: "USDC", shortName: "ETH.USDC", longName: "ETH.USDC-0XA0B86991C6218B36C1D19D4A2E9EB0CE3606EB48", geckoName: "usd-coin", binancePair: "USDCUSDT" },   
    { id: 4, prettyname: "USDT", chain: "ETH", tinyName: "USDT", shortName: "ETH.USDT", longName: "ETH.USDT-0XDAC17F958D2EE523A2206206994597C13D831EC7", geckoName: "tether", binancePair: "BUSDUSDT" },
    { id: 5, prettyname: "Rune", chain: "THOR", tinyName: "RUNE", shortName: "THOR.RUNE", longName: "THOR.RUNE", geckoName: "thorchain", binancePair: "RUNEUSDT" },
];

export const assetsInfo = AssetArray.fromData(assets);

export const coingeckoPairs = [
    { shortName: 'BTC.BTC', geckoName: 'bitcoin' },
    { shortName: 'ETH.ETH', geckoName: 'ethereum' },
    { shortName: 'ETH.USDC', geckoName: 'usd-coin' },
    { shortName: 'ETH.USDT', geckoName: 'tether' },
    { shortName: 'THOR.RUNE', geckoName: 'thorchain' },
  ];

export const binancePairs = ['BTCUSDT', 'ETHUSDT', 'USDCUSDT', 'BUSDUSDT', 'RUNEUSDT'];
